
import React from 'react';
import { Link } from 'react-router-dom';

const RelatedReading: React.FC = () => {
  return (
    <section className="mt-12 border-t border-gray-200 pt-8">
      <h2 className="text-2xl font-bold text-itmgmt-dark-blue mb-6">Related Reading</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
          <h3 className="font-semibold text-itmgmt-dark-blue mb-2">
            <Link to="/blog/cybersecurity-best-practices-small-business" className="hover:text-itmgmt-bright-blue">
              Cybersecurity Best Practices for Small Businesses
            </Link>
          </h3>
          <p className="text-gray-700 text-sm mb-3">
            Essential cybersecurity measures every small business should implement to protect sensitive data.
          </p>
          <Link to="/blog/cybersecurity-best-practices-small-business" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue text-sm font-medium">
            Read more →
          </Link>
        </div>
        
        <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
          <h3 className="font-semibold text-itmgmt-dark-blue mb-2">
            <Link to="/blog/cost-of-it-downtime-prevention" className="hover:text-itmgmt-bright-blue">
              The True Cost of IT Downtime and How to Prevent It
            </Link>
          </h3>
          <p className="text-gray-700 text-sm mb-3">
            Understanding the financial impact of IT disruptions and strategies to minimize downtime.
          </p>
          <Link to="/blog/cost-of-it-downtime-prevention" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue text-sm font-medium">
            Read more →
          </Link>
        </div>
        
        <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
          <h3 className="font-semibold text-itmgmt-dark-blue mb-2">
            <Link to="/blog/secure-document-management-cpa-firms" className="hover:text-itmgmt-bright-blue">
              Secure Document Management for CPA Firms
            </Link>
          </h3>
          <p className="text-gray-700 text-sm mb-3">
            Best practices for securely managing sensitive financial documents in accounting firms.
          </p>
          <Link to="/blog/secure-document-management-cpa-firms" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue text-sm font-medium">
            Read more →
          </Link>
        </div>
        
        <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
          <h3 className="font-semibold text-itmgmt-dark-blue mb-2">
            <Link to="/blog/technology-solutions-real-estate-agencies" className="hover:text-itmgmt-bright-blue">
              Technology Solutions for Modern Real Estate Agencies
            </Link>
          </h3>
          <p className="text-gray-700 text-sm mb-3">
            Essential tech tools and security measures for the competitive real estate industry.
          </p>
          <Link to="/blog/technology-solutions-real-estate-agencies" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue text-sm font-medium">
            Read more →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RelatedReading;
